/* eslint-disable @typescript-eslint/no-explicit-any */
import { Adress } from './BillDetailWDH'

export default function formatAdresse(adress: Adress | undefined): string {
  let formatedAddress = ''
  if (adress !== undefined) {
    const { rueAdresse, villeAdresse, codePostalAdresse } = adress
    formatedAddress += `${rueAdresse || ''} ${codePostalAdresse || ''} ${
      villeAdresse || ''
    }`
  }
  return formatedAddress
}
export function initAdressCollectPoint(item: any): string {
  const preparedAdress = item.adresseSiteClientRue || ''
  const adresseSiteClientNum = item.adresseSiteClientNom || ''

  return `${adresseSiteClientNum} ${preparedAdress}  ${item.adresseSiteClientCP}  ${item.adresseSiteClientVille} `
}
